// Core React Imports
import React from "react";

// Local Imports
import WidgetInputSecond from "../widget-input-second/WidgetInputSecond";

const WidgetInputPercent = ({ value, onChange, heightProp = "4.4rem", widthProp = "8rem", paddingRightProp = "8rem", rightPropText = "2.1rem", disabled = false }) => {
  return (
    <WidgetInputSecond
      value={value}
      onChange={onChange}
      heightProp={heightProp}
      widthProp={widthProp}
      textAlignProp="right"
      showOverlayText={true}
      paddingRightProp={paddingRightProp}
      rightPropText={rightPropText}
      disabled={disabled}
    />
  );
};

export default WidgetInputPercent;
